import React from 'react';

import Conferences from '../../components/conferences';
import Journals from '../../components/journals';
import PrePrints from '../../components/preprints';

import './index.css';

const Component = () => {
    return (
        <div className="publications">
            <h3>Publications</h3>
            <Conferences />
            <Journals />
            <PrePrints />
        </div>
    );
};

export default Component;
